var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFingerprint = function SvgFingerprint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 40,
    fill: "currentColor",
    rx: 40,
    ry: 39.518
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.068 58.032V49.74c0-7.197-5.834-13.032-13.032-13.032-7.197 0-13.032 5.835-13.032 13.032v7.108M61.776 28.39c-5.434-6.502-13.604-10.639-22.74-10.639-8.73 0-16.578 3.777-21.999 9.786"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.361 48.554c0-9.036-5.62-16.759-13.554-19.865m-7.77-1.46c-11.778 0-21.326 9.548-21.326 21.325M42.59 60.294V49.739a3.554 3.554 0 1 0-7.108 0s.196 4.667 0 6.96c-.485 5.687-3.554 8.442-3.554 8.442"
  })))));
};
export default SvgFingerprint;